import React from "react";
import style from "./VideoPlayIcon.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import cls from "classnames";
export function VideoPlayIcon(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: cls(style.playBtn, style[(props === null || props === void 0 ? void 0 : props.className) || ""])
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "vb-test/play.png")
  }));
}